module.exports = "/assets/site/images/kosarlabda.jpg?48dc3ad41d0b7480867a353f79db3c69";